// Upload Image (Link Preview)
export const UPLOAD_LINK_PREVIEW_REQUEST = 'UPLOAD_LINK_PREVIEW_REQUEST';
export const UPLOAD_LINK_PREVIEW_DONE = 'UPLOAD_LINK_PREVIEW_DONE';
export const UPLOAD_LINK_PREVIEW_FAILED = 'UPLOAD_LINK_PREVIEW_FAILED';
export const UPLOAD_LINK_PREVIEW_RESET = 'UPLOAD_LINK_PREVIEW_RESET';
